import { render, staticRenderFns } from "./afterSaleProcess.vue?vue&type=template&id=aa14d114&scoped=true"
import script from "./afterSaleProcess.vue?vue&type=script&lang=js"
export * from "./afterSaleProcess.vue?vue&type=script&lang=js"
import style0 from "./afterSaleProcess.vue?vue&type=style&index=0&id=aa14d114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa14d114",
  null
  
)

export default component.exports